import React from "react";

function WorkTime({ stateObj, setStateObj, UpdateProfile, setCurrentDiv }) {
  return (
    <div className="row">
      <div className="col-sm-6 col-md-6">
        <div className="form-group">
          <label className="form-label">Working Hours:</label>
          <input
            type="text"
            id="availabaletime"
            name="availabaletime"
            placeholder="e.g., 10AM - 6PM"
            onChange={(e) =>
              setStateObj({ ...stateObj, availabletime: e.target.value })
            }
            value={stateObj.availabletime}
            className="form-control"
          />
        </div>
      </div>
      <div className="col-sm-6 col-md-6">
        <div className="form-group">
          <label className="form-label">Typical Response Time:</label>
          <input
            type="text"
            id="typicalresponsetime"
            name="typicalresponsetime"
            placeholder="e.g., 1 hour"
            onChange={(e) =>
              setStateObj({ ...stateObj, responsetime: e.target.value })
            }
            value={stateObj.responsetime}
            className="form-control"
          />
        </div>
      </div>
      <div className="col-sm-6 col-md-6">
        <div className="form-group">
          <label className="form-label">Contact Hours:</label>
          <input
            type="text"
            id="besttimetocontact"
            name="besttimetocontact"
            placeholder="Preferred contact hours e.g., 10AM - 11AM"
            onChange={(e) =>
              setStateObj({ ...stateObj, contacttime: e.target.value })
            }
            value={stateObj.contacttime}
            className="form-control"
          />
        </div>
      </div>
      <div className="col-sm-6 col-md-6">
        <div className="form-group">
          <label className="form-label" htmlFor="linkedin">Preferred Communication Method:</label>
          <input
            type="text"
            id="prefferedtime"
            name="prefferedtime"
            placeholder="eg. email, phone...etc,"
            onChange={(e) =>
              setStateObj({
                ...stateObj,
                preferredcontact: e.target.value,
              })
            }
            value={stateObj.preferredcontact}
            className="form-control"
          />
        </div>
      </div>
      <div className="col-sm-6 col-md-6">
        <div className="form-group">
          <label className="form-label w-100" htmlFor="linkedin">
            Pricing Offered / Accepted:
            <small style={{ float: "right" }}>
              {stateObj.pricing?.length || 0} / 50
            </small>
          </label>
          <textarea
            id="pricing"
            name="pricing"
            className="form-control"
            style={{ minHeight: 100 }}
            placeholder="Hourly rates, package deals, or project-based fees"
            onChange={(e) => {
              if (e.target.value.length <= 50)
                setStateObj({ ...stateObj, pricing: e.target.value });
            }}
            value={stateObj.pricing}
          ></textarea>
        </div>
      </div>
      <div className="form-group">
        <button
          className="btn btn-primary "
          onClick={() => {
            UpdateProfile();
            setCurrentDiv("additional");
          }}
        >
          Submit
        </button>
      </div>
    </div>
  );
}

export default WorkTime;
